module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav clearfloat"
  }, [_c('ul', {
    staticClass: "container"
  }, [_c('li', {
    class: _vm.getLink('/welcome')
  }, [_c('a', {
    attrs: {
      "href": "/welcome"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', {
    class: _vm.getLink('/mall/mall')
  }, [_c('a', {
    attrs: {
      "href": "/mall/mall"
    }
  }, [_vm._v("现货商城")])]), _vm._v(" "), _c('li', {
    class: _vm.getLink('/company/company_list')
  }, [_c('a', {
    attrs: {
      "href": "/company/company_list"
    }
  }, [_vm._v("经销商列表")])]), _vm._v(" "), _c('li', {
    class: _vm.getLink('/supplier/futures')
  }, [_c('a', {
    attrs: {
      "href": "/supplier/futures"
    }
  }, [_vm._v("全球木材采购中心")])]), _vm._v(" "), _c('li', {
    class: _vm.getLink('/supplier/supply')
  }, [_c('a', {
    attrs: {
      "href": "/supplier/supply"
    }
  }, [_vm._v("供应资源")])]), _vm._v(" "), _c('li', {
    class: _vm.getLink('/support/trust')
  }, [_c('a', {
    attrs: {
      "href": "/support/trust"
    }
  }, [_vm._v("委托找货")])]), _vm._v(" "), _c('li', {
    staticClass: "down"
  }, [_vm._v("供应链\n                "), _c('ul', [_c('li', {
    class: _vm.getLink('/support/finance')
  }, [_c('a', {
    attrs: {
      "href": "/support/finance"
    }
  }, [_vm._v("金融")])]), _vm._v(" "), _c('li', {
    class: _vm.getLink('/support/logistics')
  }, [_c('a', {
    attrs: {
      "href": "/support/logistics"
    }
  }, [_vm._v("物流")])]), _vm._v(" "), _c('li', {
    class: _vm.getLink('/support/warehouse')
  }, [_c('a', {
    attrs: {
      "href": "/support/warehouse"
    }
  }, [_vm._v("仓库")])])])]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "right padding0"
  }, [_vm._v("\n                咨询热线：\n                "), _c('span', {
    staticClass: "green"
  }, [_vm._v("400-723-0868")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-528efc19"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 466
// module chunks = 31